import React from 'react';
import { getEventIcon } from 'src/utils/BigCalendarColourGeneratorUtils';
import './CategoryPill.scss';

interface CategoryPillProps {
  text: string;
  color?: string;
  textColor?: string;
  eventType?: string;
  enabled?: boolean;
  size?: 'normal' | 'small';
  centerText?: boolean;
}

const CategoryPill = ({
  text,
  color,
  textColor,
  eventType,
  enabled = true, // Default to enabled for backwards compatibility.
  size = 'normal', // Default to normal size
  centerText = false, // Default to false for backwards compatibility
}: CategoryPillProps) => {
  // Define size-specific styles
  const sizeStyles = {
    small: {
      fontSize: '11px',
      padding: '2px 6px',
      minHeight: '18px',
      gap: '2px',
    },
    normal: {
      fontSize: '13px',
      padding: '4px 8px',
      minHeight: '24px',
      gap: '4px',
    },
  };

  const currentSizeStyle = sizeStyles[size];

  // Build className string
  const pillClasses: string = [
    'tenant_pill',
    enabled ? 'enabled' : 'disabled',
    size === 'small' ? 'tenant_pill--small' : '',
    centerText ? 'tenant_pill--center' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={pillClasses}
      style={
        color
          ? {
              backgroundColor: color,
              color: textColor || 'white',
              borderColor: color,
              display: 'flex',
              alignItems: 'center',
              ...currentSizeStyle,
            }
          : {
              display: 'flex',
              alignItems: 'center',
              ...currentSizeStyle,
            }
      }
    >
      <span>{text}</span>
      {eventType && getEventIcon(eventType)}
    </span>
  );
};

export default CategoryPill;
